(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('UniversityService', UniversityService)

    /** @ngInject */
    function UniversityService(HttpService) {
        const UniversityService = {
            getAllByParameters: getAllByParameters,
            getCategories: getCategories,
            getByUrl: getByUrl,
            getCommentsByParameters: getCommentsByParameters,
            postAccessLog: postAccessLog,
            postComment: postComment
        }

        return UniversityService;

        function getCategories() {
            return HttpService.get('/videos/categories');
        }

        function getAllByParameters(params) {
            return HttpService.get('/videos/parameters', {
                params
            });
        }

        function getByUrl(url, personId, responsibilityId) {
            return HttpService.get(`/videos/${personId}/${responsibilityId}/${url}`)
        }

        function getCommentsByParameters(params) {
            return HttpService.get('/videos/comments', {
                params
            });
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/videos/access-log', accessLogData);
        }

        function postComment(commentData) {
            return HttpService.post('/videos/comments', commentData);
        }
    }
}());